import * as types from './mutation-types'

export default {
    [types.ADD_MEALS](state, data) {
        state.meals = data
    },

    [types.ADD_MEAL_SALE_ELEMENTS](state, data){
        state.mealSaleElements = data
    },

    [types.ADD_MEAL](state, data) {
        state.meals.push(data)
    },

    [types.LOAD_MEAL](state, data) {
        let mealExist = state.meals.find(x => x.id === data.id)
        if(mealExist){
            state.meals = state.meals.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.meals.push(data)
        }
    }
}

